import Api from "../../helpers/api";
import Locations from "../../helpers/locations";
import Constants from "./PlanSlotConstant";

const getAppointmentSlots = (date) => {
    
  const userFromLocal = JSON.parse(localStorage.getItem("user"));
  const patientDetails = JSON.parse(localStorage.getItem("patientDetail"));

  var zoneId = patientDetails && patientDetails?.area?.zone_data?.id
  var userToken = userFromLocal && userFromLocal?.token;

  console.log(date);
  
  let queryParam = {
    collection_date: date?.date,
    customer_zone: zoneId ?? 1, 
  };

  return function(dispatch) {
    const successCall = (response) => {
      dispatch({
        type: Constants.ACTIONS.GET_APPOINTMENT_SLOT,
        data: response?.results[0]
          ? response?.results[0].zone_data?.time_slots
          : [],
      });
    };
    const errorCall = (errorResponse) => {
        console.log(errorResponse, "Error")
    };

    Api.doGet(
      Locations.BOOKING_SLOT_COLLECTION_DATE,
      queryParam,
      successCall,
      errorCall,
      userToken
    );
  };
};

const setTimeSlotGlobal = (SelectedTimeSlot, appointmentDate) => {
  const body = {
    Time: SelectedTimeSlot,
    Date: appointmentDate,
  };
  
  return function(dispatch) {
    dispatch({
      type: Constants.ACTIONS.SET_TIME_SLOT_GLOBAL,
      data: body,
    });
    
  };
};

export default {
  getAppointmentSlots,
  setTimeSlotGlobal,
};
